var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldTicketStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.909 3.86v3.02c0 .39-.32.7-.7.7-.38 0-.7-.31-.7-.7V3.86h-1.16c-3.95 0-5.25 1.18-5.34 4.87-.01.18.07.37.2.5.13.14.3.21.5.21 1.4 0 2.55 1.16 2.55 2.56 0 1.4-1.15 2.56-2.55 2.56-.19 0-.37.07-.5.21-.13.13-.21.32-.2.5.09 3.69 1.39 4.87 5.34 4.87h1.16v-3.02c0-.39.32-.7.7-.7.38 0 .7.31.7.7v3.02h6.74c4.1 0 5.35-1.25 5.35-5.35V9.21c0-4.1-1.25-5.35-5.35-5.35h-6.74zm7.63 8.94c-.04.03-.05.09-.04.14l.22 1.27c.04.23-.05.47-.25.61-.19.14-.44.16-.65.05l-1.15-.6a.17.17 0 0 0-.14 0l-1.15.6c-.09.05-.19.07-.29.07a.625.625 0 0 1-.61-.73l.22-1.27a.18.18 0 0 0-.04-.14l-.93-.9a.616.616 0 0 1-.16-.63.59.59 0 0 1 .5-.42l1.28-.19a.2.2 0 0 0 .12-.08l.57-1.16c.11-.21.32-.34.56-.34a.6.6 0 0 1 .55.34l.57 1.16c.02.05.06.08.11.08l1.28.19c.24.03.43.2.5.42.09.22.03.46-.14.63l-.93.9z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldTicketStar);
export default __webpack_public_path__ + "static/media/vuesax-bold-ticket-star.43e5686ac1dd4835cd96280eb4cb86d2.svg";
export { ForwardRef as ReactComponent };